import styled from 'styled-components';

export const StyledLayout = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100dvh;
`;

export const StyledMain = styled.main`
  flex: 1;
`;
